/**
 * inicio
 */
function homeIconDirective() {
	scope: {
		classText: '@?'
	}
	return {
		template : function(elem, attr, s) {
			return '<i class="fa fa-home ' + (attr.classText || '') + '"></i>';
		}
	}
};
module.directive('homeIcon', [ homeIconDirective ]);
/**
 * administracion
 */
function administrationIconDirective() {
	return {
		template : '<i class="fa fa-cogs"></i>'
	};
};
module.directive('administrationIcon', [ administrationIconDirective ]);
/**
 * parametros
 */
function parametroIconDirective() {
	return {
		template : '<i class="fa fa-list-alt"></i>'
	};
};
module.directive('parameterIcon', [ parametroIconDirective ]);
/**
 * usuarios
 */
function userIconDirective() {
	scope: {
		classText: '@?'
	}
	return {
		template : function(elem, attr, s) {
			return '<i class="fa fa-users ' + (attr.classText || '') + '"></i>';
		}
	}
};
module.directive('userIcon', [ userIconDirective ]);
/**
 * Cliente
 */
function clientIconDirective() {
	return {
		template : '<i class="fa fa-suitcase"></i>'
	};
};
module.directive('clientIcon', [ clientIconDirective ]);
/**
 * elementos de muestreo
 */
function sampleElementIconDirective() {
	return {
		template : '<i class="fa fa-wrench"></i>'
	};
};
module.directive('sampleElementIcon', [ sampleElementIconDirective ]);
/**
 * producto
 */
function productIconDirective() {
	scope: {
		classText: '@?'
	}
	return {
		template : function(elem, attr, s) {
			return '<i class="fa fa-database ' + (attr.classText || '') + '"></i>';
		}
	}
};
module.directive('productIcon', [ productIconDirective ]);
/**
 * normativas
 */
function regulationIconDirective() {
	return {
		template : '<i class="fa fa-book"></i>'
	};
};
module.directive('regulationIcon', [ regulationIconDirective ]);
/**
 * analysis
 */
function analysisIconDirective() {
	scope: {
		classText: '@?'
	}
	return {
		template : function(elem, attr, s) {
			return '<i class="fa fa-bar-chart ' + (attr.classText || '') + '"></i>';
		}
	}
};
module.directive('analysisIcon', [ analysisIconDirective ]);
/**
 * técnica
 */
function techniqueIconDirective() {
	scope: {
		classText: '@?'
	}
	return {
		template : function(elem, attr, s) {
			return '<i class="fa fa-flask ' + (attr.classText || '') + '"></i>';
		}
	}
};
module.directive('techniqueIcon', [ techniqueIconDirective ]);

/**
 * auditoria
 */
function auditIconDirective() {
	return {
		template : '<i class="fa fa-sliders"></i>'
	};
};
module.directive('auditIcon', [ auditIconDirective ]);
/**
 * plan de muestreo
 */
function planSamplingIconDirective() {
	return {
		template : '<i class="fa fa-folder"></i>'
	};
};
module.directive('planSamplingIcon', [ planSamplingIconDirective ]);
/**
 * punto
 */
function siteIconDirective() {
	scope: {
		classText: '@?'
	}
	return {
		template : function(elem, attr, s) {
			return '<i class="fa fa-map-marker ' + (attr.classText || '') + '"></i>';
		}
	}
};
module.directive('siteIcon', [ siteIconDirective ]);
/**
 * area
 */
function areaIconDirective() {
	scope: {
		classText: '@?'
	}
	return {
		template : function(elem, attr, s) {
			return '<i class="fa fa-location-arrow ' + (attr.classText || '') + '"></i>';
		}
	}
};
module.directive('areaIcon', [ areaIconDirective ]);

/**
 * Informes
 */
function reportIconDirective() {
	scope: {
		classText: '@?'
	}
	return {
		template : function(elem, attr, s) {
			return '<i class="fa fa-file-o ' + (attr.classText || '') + '"></i>';
		}
	}
};
module.directive('reportIcon', [ reportIconDirective ]);
/**
 * muestra
 */
function sampleIconDirective() {
	scope: {
		classText: '@?'
	}
	return {
		template : function(elem, attr, s) {
			return '<i class="fa fa-puzzle-piece ' + (attr.classText || '') + '"></i>';
		}
	}
};
module.directive('sampleIcon', [ sampleIconDirective ]);
/**
 * analysis de muestreo
 */
function samplingAnalysisIconDirective() {
	scope: {
		classText: '@?'
	}
	return {
		template : function(elem, attr, s) {
			return '<i class="fa fa-tint ' + (attr.classText || '') + '"></i>';
		}
	}
};
module.directive('samplingAnalysisIcon', [ samplingAnalysisIconDirective ]);




